/** See `src/i18n/locales/en/reports.ts`. */
export const reports = {
  page: {
    title: 'Informes',
    lead: 'Informes de {{company}}, generados a partir de datos existentes — no se almacenan datos de informes separados.',
    noScope: 'Selecciona una empresa para ver sus informes.',
    forbidden: 'No tienes permiso para ver los informes de esta empresa.',
  },
  library: {
    title: 'Biblioteca de informes',
  },
  cards: {
    vitaliteitstrends: {
      title: 'Tendencias mensuales de vitalidad',
      description: 'Total de pasos por mes en toda la empresa.',
    },
    deelnamerapport: {
      title: 'Informe de participación',
      description: 'Cuántos miembros están activos, y desde cuándo.',
    },
    'challenge-resultaten': {
      title: 'Resultados de los desafíos',
      description: 'Desafíos por estado y progreso medio de los participantes.',
    },
    communicatiebereik: {
      title: 'Alcance de la comunicación',
      description: 'Notificaciones enviadas, entregadas y abiertas.',
    },
    documentgebruik: {
      title: 'Uso de documentos',
      description: 'Documentos publicados/archivados y su número total de vistas.',
    },
  },
  actions: {
    exportCsv: 'Exportar CSV',
    exportPdf: 'Exportar PDF',
  },
  export: {
    pdfFallbackNote:
      'La exportación a PDF aún no está disponible — en su lugar se descargó un archivo CSV.',
    error: 'No se pudo exportar este informe.',
  },
} as const;
